var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabSwitch },
          model: {
            value: _vm.tabName,
            callback: function($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "买手", name: "board" } }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "商家运营", name: "business-operator" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tabName == "board" ? _c("div", [_c("board")], 1) : _vm._e(),
      _vm._v(" "),
      _vm.tabName == "business-operator"
        ? _c("div", [_c("business-operator")], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-796f9fc3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796f9fc3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/picker/PerformanceBoard.vue
// module id = null
// module chunks = 